module.exports = __webpack_public_path__ + "img/kematian.7736ca56.jpg";